import React from "react";
import classNames from "classnames";

const Icon = ({ circle, className, children }) => {
  return <span className={classNames("custom-icon", className, { circle })}>{children}</span>;
};

export default Icon;
